import React from "react";
import { Container } from "react-bootstrap";
import InstagramIcon from "assets/svgs/instagram_icon.svg";
import HalfMediaDescription from "../half-media-description";

import {
  twoColumns, twoColumnsItems, twoColumnsText,
  twoColumnsImg, overlapImg, twoColumnsItemsReverse,
  mediaTwoColumns, twoColumnsTextComplex, imageAspect,
  twoColumnsTextComplexIcon, twoColumnsContainerResponsive,
  wordBreaksOff, alignText, topAlignText
} from "./style.mod.scss";
import RichText from "components/rich-text";
import Image from "components/image";
import useResponsiveConfig from "hooks/useResponsiveConfig";
import parsePadding from "helpers/parse-padding";


const TwoColumns = ({ data }) => {

  const {
    image, alternating, mobileAlternating, overlap, leftAlign,
    instaUrl, showInsta, mobilePadding,
    tabletPadding, desktopPadding, leftAlignText, topAlign
  } = data;

  const disableWordBreak = data?.disableWordBreak;
  const noWordBreaks = disableWordBreak ? wordBreaksOff : "";

  const config = useResponsiveConfig({
    mobile: {
      styles: parsePadding(mobilePadding),
      className: (mobileAlternating) ? twoColumnsItemsReverse : "",
    },
    tablet: {
      styles: parsePadding(tabletPadding),
      className: twoColumnsItemsReverse
    },
    desktop: {
      styles: parsePadding(desktopPadding),
      className: (alternating) ? twoColumnsItemsReverse : "",
    }
  });


  return data?.halfMedia ? <HalfMediaDescription data={data} /> : (
    <div
      className={`
        ${twoColumns}
        ${leftAlign ? mediaTwoColumns : ""}
        ${overlap ? overlapImg : ""}
        ${config.className}
        ${leftAlignText ? alignText : ""}
      `}
      style={{
        backgroundColor: data.bgColor && data.bgColor.hex,
        ...config.styles
      }}>
      <Container className={twoColumnsContainerResponsive}>
        <div className={`${twoColumnsItems} ${topAlign ? topAlignText : ""}`}>
          <div className={twoColumnsText}>
            <div className={`${twoColumnsTextComplex} ${noWordBreaks}`}>
              <RichText blocks={data.text} />
            </div>
          </div>
          <div className={`${twoColumnsImg} ${overlap ? "" : imageAspect}`}>
            {image &&
              <Image image={image} alt={image?.alt} width={800} />
            }
            {showInsta &&
              <div className={twoColumnsTextComplexIcon}>
                <a target="_blank" href={instaUrl} rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              </div>
            }
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TwoColumns;
